import React from 'react'
import { withStyles } from '@material-ui/core/styles'



const styles = (theme => ({
    root:{
      position:'static',
      textAlign:'center',
      zIndex:'1',
    },
    title2:{
      fontFamily: 'var(--font-sans)',
      fontWeight: '600',
      fontStyle: 'SemiBold',
      fontSize: '40px',
      lineHeight: '48px',
      letterSpacing: '-2%',
      textAlign: 'center',
      color: '#002857',
    },
    title3:{
      color:'#305178',
      fontFamily: 'var(--font-sans)',
      fontWeight: '400',
      fontStyle: 'Regular',
      fontSize: '20px',
      lineHeight: '30px',
      letterSpacing: '0%',
    }
})
)
let Textheader = (props) => {
   const {classes} = props
   return(
        <div className={`${classes.root} TitleHeader`}>
            <h1 className={classes.title2}>
                Resources
            </h1>
            <h6 className={classes.title3}>
                Check out our interactive demo videos.
            </h6>
        </div>
   )
}

export default withStyles(styles)(Textheader)
